import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/landingpage/Hero';
import Section1 from '../components/landingpage/Section1';
import Grid from '../assets/Grid_BG.png';
import Section2 from '../components/landingpage/Section2';
import Section3 from '../components/landingpage/Section3';
import Section4 from '../components/landingpage/Section4';
import Footer from '../components/Footer';


const LandingPage = () => { 

    useEffect(() => {
        const elements = document.querySelectorAll('.scroll-fade-in, .col-fade-in-1, .col-fade-in-2, .col-fade-in-3');

        const observer = new IntersectionObserver(
            (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                entry.target.style.animationPlayState = 'running'; // Start the animation
                observer.unobserve(entry.target); // Stop observing once the animation is triggered
                }
            });
            },
            { threshold: 0.1 } // Trigger when 10% of the element is visible
        );

        elements.forEach((el) => {
            el.style.animationPlayState = 'paused'; // Pause the animation initially
            observer.observe(el);
        });

        return () => {
            elements.forEach((el) => observer.unobserve(el)); // Cleanup observer on unmount
        };
    }, []);

  	return (
        <div className="wrapper">
            <div className='background-grid'>
                <Navbar />
                <Hero />
            </div>
                <Section1 />
                <Section2 />
                <Section3 />
                <Section4 />
                <Footer />
        </div>
    );
            
};

export default LandingPage;




                                                      																											


                                                      																											
  